/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-20 13:40:48
 */
export default {
  path: '/',
  name: 'liveManage',
  meta: {
    title: '直播控制台',
    level: 3,
    // role: ['admin'],
    icon: 'fa fa-video-camera iconTitle'
  },
  component: () => import('@/views/Application.vue'),
  hidden: true,
  children: [
    {
      path: '/liveManage/:id',
      name: 'liveManage',
      hidden: true,
      component: () => import('@/views/compmanage/live'),
      meta: {
        title: '直播控制台',
        level: 3,
        // role: ['admin'],
        icon: 'fa fa-video-camera iconTitle'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/router-live.js